/* ═══════════════════════════════════════════════════════════════════
   Tema ON Móveis.

   Cada assunto vive num bloco próprio e cada bloco roda dentro de um
   try/catch. Sem isso, um erro num assunto derruba o arquivo inteiro a
   partir dali: foi o que aconteceu com o aviso de "adicionado à caixa",
   que era o último do arquivo e nunca chegava a ser ligado quando algo
   antes dele falhava na página de produto.

   Por isso a caixa vem primeiro: é o que não pode falhar.
   ═══════════════════════════════════════════════════════════════════ */

/* ══ Busca dentro do painel ════════════════════════════════════════
   A lupa não leva para outra página. Abre o mesmo painel do menu, com
   uma linha de digitação, e os resultados aparecem embaixo conforme a
   pessoa escreve. Confirmando, a lista completa entra no lugar, ainda
   dentro do painel.

   Quem desenha os resultados é o servidor, pela seção busca-resultados,
   então o nome curto, o preço e a linha saem exatamente como no resto
   da loja.
   ═══════════════════════════════════════════════════════════════ */
try {
/* ── trava de rolagem, uma para o tema inteiro ────────────────────
   Painel, janela lateral, zoom, stories e a janela da caixa travam a
   página enquanto estão abertos. Um contador deixa uma trava abrir por
   cima da outra (a janela por cima do painel) sem destravar antes da
   hora. No iOS, overflow:hidden no body não segura a página: quando um
   campo ganha foco e o teclado sobe, o documento rola por baixo e os
   elementos fixos (dock, painel) saem do lugar, às vezes para sempre,
   até a próxima rolagem. Fixar o body na posição em que estava, e
   devolver a rolagem exata ao destravar, é o que segura tudo no lugar. */
(function () {
  'use strict';
  var travas = 0, y = 0;
  /* v200: travar a página sem mexer nela.
     Antes, o corpo da página ficava fixo (position:fixed) enquanto um menu ou janela
     estava aberto, e as alturas eram medidas à mão. No iOS 26, depois de a barra do
     Safari recolher e voltar (o bloco 3D é o primeiro lugar alto o bastante para isso),
     essas medidas vinham erradas: janelas subidas, barra de baixo sumindo, menu curto.
     Agora a página só deixa de rolar (overflow escondido) e os painéis ocupam a tela do
     mesmo jeito que a barra de baixo ocupa sem nada aberto, que o Safari sempre acerta.
     O corpo fixo e as medidas ficam só para quando o teclado está aberto num campo de
     uma janela (CEP, cupom, busca), que é o caso em que o iOS empurra a página. */
  var vv = window.visualViewport, hBase = 0, teclado = false;
  function campo() {
    var a = document.activeElement;
    return !!a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable);
  }
  function medeTela() {
    var h = Math.round(vv ? vv.height : window.innerHeight);
    if (hBase && h > hBase) hBase = h;
    var t = vv ? Math.max(0, Math.round(vv.offsetTop)) : 0;
    document.documentElement.style.setProperty('--vvh', h + 'px');
    document.documentElement.style.setProperty('--vvt', t + 'px');
  }
  function entraTeclado() {
    if (teclado || travas === 0 || !campo()) return;
    teclado = true;
    hBase = Math.round(vv ? vv.height : window.innerHeight);
    medeTela();
    document.documentElement.style.setProperty('--travaTop', (-y) + 'px');
    document.body.classList.add('teclado');
    if (vv) { vv.addEventListener('resize', medeTela); vv.addEventListener('scroll', medeTela); }
    window.addEventListener('resize', medeTela);
  }
  function saiTeclado() {
    if (!teclado) return;
    teclado = false;
    document.body.classList.remove('teclado');
    document.documentElement.style.removeProperty('--travaTop');
    document.documentElement.style.removeProperty('--vvt');
    if (vv) { vv.removeEventListener('resize', medeTela); vv.removeEventListener('scroll', medeTela); }
    window.removeEventListener('resize', medeTela);
    hBase = 0;
    window.scrollTo(0, y);
  }
  function focoEntra() { if (travas > 0) entraTeclado(); }
  function focoSai() { setTimeout(function () { if (!campo()) saiTeclado(); }, 260); }
  function trava(liga) {
    if (liga) {
      if (travas++ === 0) {
        y = window.scrollY || window.pageYOffset || 0;   // onde a página estava; volta para cá depois do teclado
        document.documentElement.classList.add('travado');
        document.body.classList.add('lock');
        document.addEventListener('focusin', focoEntra);
        document.addEventListener('focusout', focoSai);
        if (campo()) entraTeclado();
      }
    } else if (travas > 0 && --travas === 0) {
      document.removeEventListener('focusin', focoEntra);
      document.removeEventListener('focusout', focoSai);
      saiTeclado();
      document.body.classList.remove('lock');
      document.documentElement.classList.remove('travado');
    }
  }
  /* ── foco preso num diálogo ──────────────────────────────────────
     Tab e Shift+Tab circulam só dentro do painel aberto (menu, janela
     lateral, filtros, fotos, stories, confirmação). Um de cada vez: o
     último a prender é o que vale; soltar devolve ao anterior. */
  var pilha = [];
  var FOCAVEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  var visivel = function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); };
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !pilha.length) return;
    var cx = pilha[pilha.length - 1];
    var itens = Array.prototype.filter.call(cx.querySelectorAll(FOCAVEL), visivel);
    if (!itens.length) { e.preventDefault(); return; }
    var pri = itens[0], ult = itens[itens.length - 1];
    if (e.shiftKey && (document.activeElement === pri || !cx.contains(document.activeElement))) { e.preventDefault(); ult.focus(); }
    else if (!e.shiftKey && (document.activeElement === ult || !cx.contains(document.activeElement))) { e.preventDefault(); pri.focus(); }
  });
  window.ONM = window.ONM || {};
  ONM.trava = trava;
  ONM.foco = {
    prende: function (cx) { if (cx && pilha.indexOf(cx) < 0) pilha.push(cx); },
    solta: function (cx) { var i = pilha.indexOf(cx); if (i > -1) pilha.splice(i, 1); }
  };
})();

(function () {
  'use strict';
  var caixa = document.getElementById('menuBusca');
  if (!caixa) return;
  var campo = document.getElementById('buscaCampo');
  var saida = document.getElementById('buscaSaida');
  var form = caixa.querySelector('.bsc');
  var espera = null, pedido = 0, ultimo = '';

  function abre() {
    if (!window.ONM || !ONM.painel) return false;
    ONM.painel.abre('busca');
    setTimeout(function () { if (campo) campo.focus(); }, 320);
    if (!ultimo) procura('', false);         // atalhos enquanto nada foi digitado
    return true;
  }

  function procura(termo, completa) {
    var meu = ++pedido;
    var url;
    if (!termo) {
      // sem nada escrito não há o que buscar: a seção vem só com os atalhos
      url = '/?section_id=busca-resultados';
    } else if (completa) {
      url = '/search?q=' + encodeURIComponent(termo) + '&type=product&section_id=busca-resultados';
    } else {
      url = '/search/suggest?q=' + encodeURIComponent(termo) +
        '&resources[type]=product&resources[limit]=8&section_id=busca-resultados';
    }
    saida.classList.add('bsc__saida--carrega');
    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        if (meu !== pedido) return;          // resposta antiga: descarta
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bloco = doc.querySelector('[data-busca-resultados]');
        if (!bloco) throw new Error('sem resultados');
        saida.innerHTML = '';
        saida.appendChild(document.importNode(bloco, true));
        saida.classList.remove('bsc__saida--carrega');
      })
      .catch(function () {
        saida.classList.remove('bsc__saida--carrega');
        saida.innerHTML = termo ? '<p class="bsc__vazio">Não deu para buscar agora.</p>' : '';
      });
  }

  if (campo) {
    campo.addEventListener('input', function () {
      var t = campo.value.trim();
      ultimo = t;
      clearTimeout(espera);
      espera = setTimeout(function () { procura(t, false); }, t ? 220 : 0);
    });
  }
  // Enter no campo: envio comum do formulário, que leva à página de
  // resultados completa. As sugestões no painel são só o atalho.
  if (form) {
    form.addEventListener('submit', function (e) {
      clearTimeout(espera);
      if (!campo.value.trim()) e.preventDefault();
    });
  }

  // "Ver todos os resultados" também fica no painel
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-busca-tudo]')) {
      e.preventDefault();
      if (campo && campo.value.trim() && form) form.submit();
      return;
    }
    var lupa = e.target.closest('[data-abre-busca], a[href$="/search"]');
    if (lupa && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      if (abre()) e.preventDefault();
    }
  });
})();
} catch (e) { if (window.console && console.warn) console.warn('ON: a busca falhou e o resto seguiu.', e); }


/* ══ A caixa: gaveta e o colocar ═══════════════════════════════════
   Um bloco só, isolado do resto do script, cuidando de tudo que envolve
   a caixa. É o momento mais importante da loja e não pode depender de
   nenhuma outra parte funcionar.

   A caixa é uma gaveta, não uma página. O conteúdo vem pronto do
   servidor pela API de renderização, então preço, desconto e frete saem
   do Shopify, sem conta feita no navegador.

   Ao colocar um móvel, o pedido vai por trás e sobe a janela de
   confirmação com o que entrou. Nada leva para a página do carrinho: se
   a rede falhar, a própria janela avisa, em vez de recarregar.

   Diagnóstico: abra qualquer página com ?caixa no fim do endereço.
   ═══════════════════════════════════════════════════════════════ */
try {
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var largo = function () { return matchMedia('(min-width:1000px)').matches; };
  var dinheiro = function (c) {
    return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };
  var rotas = (window.ONM && ONM.rotas) || { carrinho: '/cart', adicionar: '/cart/add', mudar: '/cart/change', raiz: '/' };
  if (!rotas.raiz) rotas.raiz = '/';

  var diag = /[?&]caixadebug\b/.test(location.search) ? [] : null;
  function anota(t) {
    if (!diag) return;
    diag.push(t);
    var cx = document.getElementById('caixaDiag');
    if (!cx) {
      cx = document.createElement('div');
      cx.id = 'caixaDiag';
      cx.style.cssText = 'position:fixed;left:10px;bottom:90px;z-index:9999;max-width:min(520px,92vw);' +
        'max-height:50vh;overflow:auto;background:#111;color:#eee;font:12px/1.5 monospace;' +
        'padding:12px 14px;border-radius:6px;white-space:pre-wrap';
      document.body.appendChild(cx);
    }
    cx.textContent = 'CAIXA\n' + diag.join('\n');
  }

  function caixaVisivel(n) {
    $$('[data-caixa]').forEach(function (c) { c.classList.toggle('cxa--off', !(n > 0)); });
  }


  /* ── os botões de fechar a compra, vestidos por JS ─────────────────
     O app do Pix clona o nosso botão de finalizar, com classe, atributos
     e tudo, e só troca o texto. Nenhum seletor de CSS separa os dois com
     segurança, e o app ainda escreve estilo por cima. Então quem separa
     é o texto: o que não for o nosso rótulo é o clone, e recebe a forma
     da casa em estilo inline com !important, o único nível que vence
     qualquer coisa. Um observador refaz isso sempre que algo entra no
     contêiner, na hora que for. */
  try {
    var vesteAcoes = function (cx) {
      var rot = (cx.dataset.rotulo || '').trim().toLowerCase();
      var escuro = cx.dataset.acoes === 'escuro';
      var par = cx.classList.contains('cxd__acoes--par');   // lado a lado: fonte menor
      // o app pode pôr o clone fora do nosso bloco (irmão dele, ou num
      // invólucro próprio): procura no rodapé inteiro da gaveta
      var raiz = (par && cx.closest('.cxd__acoesW')) || cx;
      var todos = $$('a,button', raiz).filter(function (el) { return !el.closest('.compart'); });
      var nosso = null;
      todos.forEach(function (el) { if (!nosso && el.textContent.trim().toLowerCase() === rot) nosso = el; });
      // lado a lado: o ancestral comum dos dois vira uma linha flex e os
      // dois ramos dividem a largura, com o clone à esquerda
      if (par && nosso) {
        var clone = null;
        todos.forEach(function (el) { if (!clone && el !== nosso && !nosso.contains(el) && !el.contains(nosso)) clone = el; });
        if (clone) {
          var lca = clone.parentNode;
          while (lca && lca !== raiz.parentNode && !lca.contains(nosso)) lca = lca.parentNode;
          if (lca && lca.contains(nosso)) {
            var ramo = function (el) { var r = el; while (r.parentNode !== lca) r = r.parentNode; return r; };
            var rc = ramo(clone), rn = ramo(nosso);
            var L = lca.style;
            [['display', 'flex'], ['flex-direction', 'row'], ['flex-wrap', 'nowrap'], ['align-items', 'stretch'], ['gap', '8px']].forEach(function (kv) {
              if (L.getPropertyValue(kv[0]) !== kv[1]) L.setProperty(kv[0], kv[1], 'important');
            });
            [rc, rn].forEach(function (r, i) {
              var R = r.style;
              [['flex', '1 1 0'], ['min-width', '0'], ['width', 'auto'], ['margin', '0'], ['order', String(i + 1)]].forEach(function (kv) {
                if (R.getPropertyValue(kv[0]) !== kv[1]) R.setProperty(kv[0], kv[1], 'important');
              });
            });
            Array.prototype.forEach.call(lca.children, function (ch) {
              if (ch !== rc && ch !== rn && !ch.textContent.trim() && !ch.querySelector('a,button,img,svg')) ch.style.setProperty('display', 'none', 'important');
            });
          }
        }
      }
      // o clone fica exatamente da altura do nosso, seja ela qual for
      var alto = nosso ? (getComputedStyle(nosso).height || '48px') : '48px';
      todos.forEach(function (el) {
        var meu = el === nosso;
        var st = el.style;
        if (st.getPropertyValue('order') !== (meu ? '2' : '1')) st.setProperty('order', meu ? '2' : '1', 'important');
        if (meu) return;
        var kv = {
          'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'gap': '8px',
          'width': '100%', 'height': alto, 'min-height': '0', 'padding': par ? '0 10px' : '0 20px', 'margin': '0',
          'border': '0', 'border-radius': '999px', 'cursor': 'pointer', 'text-decoration': 'none',
          'text-shadow': 'none', 'text-transform': 'none', 'letter-spacing': '0', 'line-height': '1.2',
          'font-family': 'var(--titulo)', 'font-weight': '600', 'font-size': par ? '13.5px' : (escuro ? '14.5px' : '15px'),
          'white-space': 'nowrap',
          'background-image': 'none', 'float': 'none', 'position': 'static', 'transform': 'none',
          'background-color': escuro ? 'transparent' : '#ffffff',
          'color': escuro ? '#ffffff' : '#1c1c1c',
          'box-shadow': escuro ? 'inset 0 0 0 1px #ffffff' : '0 1px 2px rgba(0,0,0,.06)'
        };
        Object.keys(kv).forEach(function (k) { if (st.getPropertyValue(k) !== kv[k] || st.getPropertyPriority(k) !== 'important') st.setProperty(k, kv[k], 'important'); });
        $$('img,svg', el).forEach(function (m) { m.style.setProperty('max-height', '18px', 'important'); m.style.setProperty('width', 'auto', 'important'); });
      });
    };
    var cxs = $$('[data-acoes]');
    cxs.forEach(function (cx) {
      vesteAcoes(cx);
      // o app do Pix escreve o próprio style depois de inserir o clone (e
      // ele ficava preto de novo). Observa também os atributos, com um
      // teto de reaplicações pra nunca entrar em cabo de guerra.
      if ('MutationObserver' in window) {
        var vezes = 0, agendado = false;
        new MutationObserver(function () {
          if (agendado || vezes > 30) return;
          agendado = true;
          requestAnimationFrame(function () { agendado = false; vezes++; vesteAcoes(cx); });
        }).observe((cx.classList.contains('cxd__acoes--par') && cx.closest('.cxd__acoesW')) || cx, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      }
    });
  } catch (e) {}

  /* ── a caixa dentro do painel do menu ──────────────────────────────
     Não existe gaveta separada nem página: é o mesmo painel do
     hambúrguer, com outro conteúdo. Se o painel ainda não estiver
     ligado, a caixa abre sozinha assim que ele estiver.
     ─────────────────────────────────────────────────────────────── */
  var dentro = document.getElementById('menuCaixa');

  function abreCaixa() {
    if (!dentro || !window.ONM || !ONM.painel) { location.href = rotas.carrinho; return; }
    ONM.painel.abre('caixa');
    carrega();
  }

  function carrega() {
    if (!dentro) return;
    dentro.classList.add('menu__caixa--carrega');
    fetch(rotas.carrinho + '?section_id=caixa-drawer', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var corpo = doc.querySelector('[data-caixa-corpo]');
        if (!corpo) throw new Error('sem conteúdo');
        var miolo = document.getElementById('menuCaixaIn') || dentro;
        var itens = parseInt(corpo.dataset.itens, 10) || 0;
        miolo.innerHTML = '';
        miolo.appendChild(document.importNode(corpo, true));
        var acoes = document.getElementById('menuCaixaAcoes');
        if (acoes) acoes.hidden = itens === 0;      // os botões vivem no painel, não no conteúdo
        // no celular o detalhamento do resumo nasce recolhido: os itens
        // precisam aparecer antes de tudo
        caixaVisivel(itens);
        var st = document.getElementById('caixaStatus');
        if (st) st.textContent = itens === 0 ? 'Caixa vazia' : 'Caixa atualizada: ' + itens + (itens === 1 ? ' item' : ' itens');
        dentro.classList.remove('menu__caixa--carrega');
        if (window.ONM && ONM.ligaCep) ONM.ligaCep();   // religa a cotação de frete
        preparaCompart();
        anota('caixa carregada, itens: ' + corpo.dataset.itens);
      })
      .catch(function (err) {
        dentro.classList.remove('menu__caixa--carrega');
        dentro.innerHTML = '<p class="cxd__erro">Não deu para carregar a caixa agora.</p>';
        anota('caixa falhou: ' + err.message);
      });
  }

  function mexe(linha, qtd) {
    if (dentro) dentro.classList.add('menu__caixa--carrega');
    fetch(rotas.mudar + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linha, quantity: qtd })
    }).then(function (r) { return r.json(); })
      .then(function () { carrega(); })
      .catch(function () { carrega(); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var link = e.target.closest('[data-caixa], [data-abre-caixa], a[href$="/cart"]');
    if (link && !link.hasAttribute('data-sem-gaveta') && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      abreCaixa();
      return;
    }

    var q = e.target.closest('[data-q]');
    if (q && dentro && dentro.contains(q)) {
      var item = q.closest('[data-linha]');
      if (!item) return;
      var linha = parseInt(item.dataset.linha, 10);
      var atual = parseInt(item.querySelector('[data-qtd]').textContent, 10) || 1;
      var acao = q.dataset.q;
      mexe(linha, acao === 'fora' ? 0 : (acao === 'mais' ? atual + 1 : Math.max(0, atual - 1)));
      return;
    }

  });

  /* ── página do carrinho com o mesmo motor da gaveta ────────────────
     Antes cada + ou − recarregava a página inteira e a quantidade
     digitada só valia ao clicar em finalizar. Agora: /cart/change.js e a
     seção volta pela API de renderização; só o formulário é trocado,
     então os complementares e a faixa ficam. Sem JS o formulário
     continua funcionando do jeito comum. */
  var carrPag = document.getElementById('formCarrinho');
  if (carrPag && carrPag.dataset.secao) {
    var carrSecao = carrPag.dataset.secao;
    var carrOcupado = false;
    var carrRedesenha = function () {
      return fetch(rotas.carrinho + '?section_id=' + encodeURIComponent(carrSecao), { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { if (!r.ok) throw 0; return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var novo = doc.getElementById('formCarrinho');
          var atual = document.getElementById('formCarrinho');
          if (!novo || !atual) { location.reload(); return; }   // esvaziou: a página muda de forma
          atual.replaceWith(document.importNode(novo, true));
          var n = doc.querySelectorAll('#formCarrinho .li').length;
          caixaVisivel(n);
          if (window.ONM && ONM.ligaCep) ONM.ligaCep();
        });
    };
    var carrMuda = function (linha, qtd) {
      if (carrOcupado) return;
      carrOcupado = true;
      var f = document.getElementById('formCarrinho'); if (f) f.classList.add('carr--carrega');
      fetch(rotas.mudar + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: linha, quantity: qtd }) })
        .then(function (r) { if (!r.ok) throw 0; })
        .then(carrRedesenha)
        .catch(function () { location.reload(); })
        .then(function () { carrOcupado = false; var f2 = document.getElementById('formCarrinho'); if (f2) f2.classList.remove('carr--carrega'); });
    };
    var linhaDe = function (el) { var li = el.closest('[data-linha]'); return li ? parseInt(li.dataset.linha, 10) : 0; };
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var f = e.target.closest('#formCarrinho'); if (!f) return;
      var mais = e.target.closest('[data-mais]'), menos = e.target.closest('[data-menos]'), rm = e.target.closest('.li__x');
      if (!mais && !menos && !rm) return;
      e.preventDefault();
      var el = mais || menos || rm, linha = linhaDe(el); if (!linha) return;
      var inp = el.closest('.li').querySelector('input[name="updates[]"]');
      var atual = inp ? (parseInt(inp.value, 10) || 0) : 1;
      carrMuda(linha, rm ? 0 : (mais ? atual + 1 : Math.max(0, atual - 1)));
    });
    document.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('#formCarrinho input[name="updates[]"]')) return;
      var linha = linhaDe(inp); if (!linha) return;
      carrMuda(linha, Math.max(0, parseInt(inp.value, 10) || 0));
    });
  }

  /* ── compartilhar a caixa ──────────────────────────────────────────
     Lê a caixa (/cart.js) e monta o permalink nativo do Shopify:
     /cart/VARIANTE:QTD,VARIANTE:QTD. Vai com o cupom aplicado
     (?discount=) e, quando quem compartilha é da equipe (ONM.vendedor),
     com o nome gravado no pedido em attributes[Vendedor]. O parâmetro
     caixa=compartilhada só serve para a página do carrinho mostrar a
     faixa de boas-vindas. Quem abre o link tem a própria caixa
     SUBSTITUÍDA por esta: é o que o comercial quer ao montar para o
     cliente. Os ouvintes ficam no documento porque os botões chegam com
     o resumo pela API de renderização. */
  function leCaixaJson() {
    return fetch(rotas.carrinho + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  function linkDaCaixa(c, origem) {
    var itens = (c.items || []).map(function (it) { return it.variant_id + ':' + it.quantity; });
    if (!itens.length) return null;
    // O link é do próprio tema (home + ?caixa=...): ao abrir, o JS monta a
    // caixa e abre a gaveta. Não é o permalink do Shopify porque ele cai
    // no checkout ou na página de carrinho, e aqui a caixa é uma só, a
    // gaveta, com Pix e cartão em botões separados.
    var q = ['caixa=' + itens.join(',')];
    (c.discount_codes || []).forEach(function (d) {
      if (d && d.code && d.applicable !== false) q.push('cupom=' + encodeURIComponent(d.code));
    });
    var v = window.ONM && ONM.vendedor;
    if (v) q.push('v=' + encodeURIComponent(v));
    // origem: quem clica no link chega com UTM (WhatsApp da loja ou
    // compartilhamento entre pessoas), e o GA4 registra a origem
    var utm = origem === 'loja' ? 'utm_source=whatsapp&utm_medium=carrinho&utm_campaign=caixa_loja' : 'utm_source=compartilhado&utm_medium=carrinho&utm_campaign=caixa_amigo';
    return location.origin + rotas.raiz + '?' + q.join('&') + '&' + utm;
  }
  // nome curto da linha (o mesmo da gaveta), lido do HTML; sem ele, o
  // título do cadastro
  function nomeDaLinha(i, it) {
    var el = document.querySelector('[data-linha="' + (i + 1) + '"][data-nome]');
    return (el && el.dataset.nome) || it.product_title || it.title;
  }
  /* modo 'loja': mensagem pro comercial (abre no WhatsApp da ON).
     modo 'gente': texto pra mandar pra outra pessoa (folha de
     compartilhar); quem é da equipe manda como "montei pra você". */
  function textoDaCaixa(c, link, modo) {
    var pr = (window.ONM && ONM.preco) || { pix: 0, pmax: 12, pmin: 15000 };
    var zap = (window.ONM && ONM.zap) || {};
    var linhas = (c.items || []).map(function (it, i) {
      return '• ' + it.quantity + 'x ' + nomeDaLinha(i, it);
    });
    var total = c.total_price || 0;
    var n = Math.max(1, Math.min(pr.pmax || 12, Math.floor(total / (pr.pmin || 15000))));
    var partes = [];
    if (modo === 'gente') partes.push((window.ONM && ONM.vendedor) ? (zap.txtEquipe || 'Montei esta caixa pra você na ON Móveis:') : (zap.txtGente || 'Olha a caixa que montei na ON Móveis:'));
    else partes.push((zap.msg || 'Olá! Montei uma caixa no site e quero fechar com a ajuda de vocês.'));
    partes.push('');
    partes.push('*Itens da caixa*');
    partes.push(linhas.join('\n'));
    partes.push('');
    if (pr.pix > 0) {
      partes.push('*Total no Pix:* ' + dinheiro(Math.floor(total * (100 - pr.pix) / 100)));
      partes.push('ou ' + dinheiro(total) + (n > 1 ? ' em até ' + n + 'x de ' + dinheiro(Math.floor(total / n)) + ' sem juros' : ' no cartão'));
    } else {
      partes.push('*Total:* ' + dinheiro(total));
    }
    if (link) {
      partes.push('');
      partes.push(modo === 'gente' ? 'É só abrir o link: a caixa já vem montada, pronta pra finalizar por Pix ou cartão.' : 'Caixa pronta, é só abrir e finalizar:');
      partes.push(link);
    }
    if (modo !== 'gente' && zap.fim) { partes.push(''); partes.push(zap.fim); }
    return partes.join('\n');
  }
  function marcaCompart(origem, c) {
    var dados = { event: 'caixa_compartilhada', compart_origem: origem, compart_itens: c.item_count || 0, compart_valor: (c.total_price || 0) / 100 };
    try {
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(dados);
      if (typeof window.gtag === 'function') gtag('event', 'caixa_compartilhada', { origem: origem, itens: dados.compart_itens, valor: dados.compart_valor });
    } catch (e) {}
  }
  function avisaCompart(b, t) {
    var r = b.querySelector('[data-compart-rotulo]'); if (!r) return;
    if (!r.dataset.orig) r.dataset.orig = r.textContent;
    r.textContent = t; b.classList.add('compart__b--ok');
    setTimeout(function () { r.textContent = r.dataset.orig; b.classList.remove('compart__b--ok'); }, 2600);
  }
  function copia(t) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(t);
    return new Promise(function (ok, falha) {
      var ta = document.createElement('textarea'); ta.value = t; ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;left:-9999px'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) { falha(e); } ta.remove();
    });
  }
  /* Os textos ficam prontos ANTES do clique, sempre que a gaveta é
     desenhada. Motivo: o WhatsApp só abre direto no app (sem a página
     do api.whatsapp.com e sem pedir permissão) quando o clique é num
     <a href="https://wa.me/..."> de verdade, no mesmo gesto. Navegar
     por JS depois de um fetch perde isso. O mesmo vale pra folha de
     compartilhar do celular, que exige o gesto ainda vivo. */
  var pronto = null;
  function preparaCompart() {
    var botoes = $$('[data-compartilhar-zap], [data-compartilhar]');
    if (!botoes.length) return;
    leCaixaJson().then(function (c) {
      if (!c || !(c.items || []).length) { pronto = null; return; }
      var num = window.ONM && ONM.zap && ONM.zap.num;
      var linkLoja = linkDaCaixa(c, 'loja'), linkGente = linkDaCaixa(c, 'gente');
      pronto = { c: c, gente: textoDaCaixa(c, linkGente, 'gente'), loja: textoDaCaixa(c, linkLoja, 'loja') };
      $$('[data-compartilhar-zap]').forEach(function (z) {
        if (z.tagName === 'A' && num) z.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(pronto.loja);
      });
    }).catch(function () { pronto = null; });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-compartilhar]');
    var z = e.target.closest('[data-compartilhar-zap]');
    if (!b && !z) return;
    if (z) {
      // é um <a> com o href pronto: deixa o navegador abrir o WhatsApp no
      // mesmo gesto; só registra o evento. Sem href pronto, copia o texto.
      if (pronto) marcaCompart('whatsapp', pronto.c);
      if (z.tagName === 'A' && /wa\.me\/\d+\?text=/.test(z.href)) return;
      e.preventDefault();
      if (pronto) { copia(pronto.loja); avisaCompart(z, 'Copiado'); } else preparaCompart();
      return;
    }
    e.preventDefault();
    if (b.disabled) return;
    var vai = function (p) {
      if (navigator.share && !largo()) {
        marcaCompart('folha', p.c);
        b.disabled = true;
        navigator.share({ title: 'Caixa ON Móveis', text: p.gente }).catch(function () {}).then(function () { b.disabled = false; });
        return;
      }
      copia(p.gente).then(function () { marcaCompart('copiar', p.c); avisaCompart(b, 'Copiado, é só colar'); },
        function () { avisaCompart(b, 'Não deu para copiar'); });
    };
    if (pronto) { vai(pronto); return; }
    // sem preparo (clique muito rápido): monta agora; a folha pode não
    // abrir por falta de gesto, e aí o texto vai pra área de transferência
    leCaixaJson().then(function (c) {
      pronto = { c: c, gente: textoDaCaixa(c, linkDaCaixa(c, 'gente'), 'gente'), loja: textoDaCaixa(c, linkDaCaixa(c, 'loja'), 'loja') };
      vai(pronto);
    }).catch(function () { avisaCompart(b, 'Tente de novo'); });
  });

  /* ── chegada por link: ?caixa=VARIANTE:QTD,... (&cupom=, &v=) ───
     Monta a caixa do zero (limpa, adiciona, grava os atributos e o
     cupom) e abre a gaveta. ?caixa=abrir só abre a gaveta (é pra onde
     /cart redireciona). A URL fica limpa depois, pra um recarregar não
     montar tudo de novo. */
  (function () {
    var m = /[?&]caixa=([^&]+)/.exec(location.search); if (!m) return;
    var val = decodeURIComponent(m[1]);
    var pega = function (k) { var r = new RegExp('[?&]' + k + '=([^&]+)').exec(location.search); return r ? decodeURIComponent(r[1].replace(/\+/g, ' ')) : ''; };
    var cupom = pega('cupom'), vend = pega('v');
    var limpaUrl = function () {
      try { var u = new URL(location.href); ['caixa', 'cupom', 'v'].forEach(function (k) { u.searchParams.delete(k); }); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash); } catch (e) {}
    };
    // o painel (ONM.painel) nasce num bloco mais abaixo deste arquivo:
    // abre no próximo tique, quando tudo já rodou
    var abre = function () {
      setTimeout(function () { if (window.ONM && ONM.painel) abreCaixa(); }, 0);   // sem painel não redireciona pra /cart (viraria um laço)
    };
    var post = function (rota, corpo) {
      return fetch(rota, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo) })
        .then(function (r) { if (!r.ok) throw new Error(rota + ' ' + r.status); return r.json(); });
    };
    if (val === 'abrir') { limpaUrl(); abre(); return; }
    var itens = val.split(',').map(function (par) {
      var p = par.split(':'); return { id: parseInt(p[0], 10), quantity: Math.max(1, parseInt(p[1], 10) || 1) };
    }).filter(function (i) { return i.id > 0; });
    if (!itens.length) { limpaUrl(); abre(); return; }
    var attrs = { caixa: 'compartilhada' };
    if (vend) attrs.Vendedor = vend;
    post(rotas.carrinho + '/clear.js', {})
      .then(function () { return post(rotas.carrinho + '/add.js', { items: itens }); })
      .then(function () { var u = { attributes: attrs }; if (cupom) u.discount = cupom; return post(rotas.carrinho + '/update.js', u); })
      .catch(function () { return post(rotas.carrinho + '/update.js', { attributes: attrs }).catch(function () {}); })
      .then(function () {
        try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'caixa_compartilhada_aberta', itens: itens.length }); } catch (e) {}
        limpaUrl(); abre();
      });
  })();

  /* A janela de confirmação não mora mais aqui: ela é um snippet com
     script próprio na página, para não depender deste arquivo. O que
     fica é o atalho que ela usa para abrir a caixa no painel. */
  window.ONM = window.ONM || {};
  ONM.abreCaixa = abreCaixa;
  ONM.carregaCaixa = carrega;   // o cupom e o frete pedem um redesenho depois de mudar o carrinho
  preparaCompart();   // página do carrinho (reserva sem JS) já nasce com os botões

})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }


/* ══ ON Móveis · script único ══════════════════════════════════════
   Sem framework e sem dependência. Tudo é opcional: se o elemento não
   existe na página, o bloco simplesmente não roda.
   ═══════════════════════════════════════════════════════════════ */
try {
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUZ = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var largo = function () { return matchMedia('(min-width:1000px)').matches; };
  var limpar = function (el) { el.getAnimations().forEach(function (a) { a.cancel(); }); };


  /* ── marca: rolamento em formação ──────────────────────────────
     A palavra vem montada e rola inteira de trás do símbolo. A borda
     do vão anda junto com ela, com uma folga à direita para a letra
     girada não encostar. Nenhuma opacidade em momento nenhum. */
  var FOLGA = 0.30;
  // No desktop, a palavra do topo rola quando o menu abre: é o efeito
  // da marca. No celular o topo fica quieto, o painel cobre a tela e
  // tem a própria marca, essa sim animada. A checagem é feita na hora,
  // então redimensionar a janela troca o comportamento sem religar nada.
  var marcas = $$('.lg');
  var marcaViva = function (l) { return largo() || !l.closest('.top'); };
  var aberta = false;

  function medirMarca() {
    marcas.forEach(function (l) {
      if (!marcaViva(l)) return;
      var w = $('.lg__w', l), wrap = $('.lg__wrap', l);
      if (!w || !wrap) return;
      var cs = getComputedStyle(w);
      var em = parseFloat(cs.fontSize) || 16;
      l._em = em;
      l._fw = w.getBoundingClientRect().width + (parseFloat(cs.marginLeft) || 0) + em * FOLGA;
      l._letras = $$('.l', w);
      l._palavra = w;
      if (aberta) wrap.style.width = l._fw + 'px';
    });
  }
  function animarMarca(abrir) {
    if (abrir === aberta) return;
    aberta = abrir;
    var vel = (window.ONM && ONM.vel) || 11;
    var voltas = (window.ONM && ONM.voltas != null) ? ONM.voltas : 0.75;
    marcas.forEach(function (l) {
      if (!marcaViva(l)) return;
      var wrap = $('.lg__wrap', l); if (!wrap) return;
      var em = l._em || 16, largura = l._fw || 0;
      var t = Math.max(1, Math.round(largura / (vel * em) * 1000 * (REDUZ ? 0.55 : 1)));
      var de = wrap.getBoundingClientRect().width;
      limpar(wrap);
      wrap.style.width = (abrir ? largura : 0) + 'px';
      wrap.animate([{ width: de + 'px' }, { width: (abrir ? largura : 0) + 'px' }],
        { duration: t, easing: 'linear', fill: 'both' });

      if (l._palavra) {
        limpar(l._palavra);
        l._palavra.animate(abrir
          ? [{ transform: 'translateX(' + (-largura) + 'px)' }, { transform: 'none' }]
          : [{ transform: 'none' }, { transform: 'translateX(' + (-largura) + 'px)' }],
          { duration: t, easing: 'linear', fill: 'both' });
      }
      var g = -voltas * 360;
      (l._letras || []).forEach(function (el) {
        limpar(el);
        el.animate(abrir
          ? [{ transform: 'rotate(' + g + 'deg)' }, { transform: 'none' }]
          : [{ transform: 'none' }, { transform: 'rotate(' + g + 'deg)' }],
          { duration: t, easing: 'linear', fill: 'both' });
      });
      var m = $('.lg__m', l);
      if (m) {                       // o símbolo é a roda de tração
        limpar(m);
        m.animate(abrir
          ? [{ transform: 'rotate(-360deg)' }, { transform: 'none' }]
          : [{ transform: 'none' }, { transform: 'rotate(-360deg)' }],
          { duration: t, easing: 'linear', fill: 'both' });
      }
    });
  }
  medirMarca();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(medirMarca);
  addEventListener('resize', medirMarca);

  /* ── menu ─────────────────────────────────────────────────────── */
  var menu = $('#onmMenu');
  var burgs = $$('.burg');
  var cats = $$('.cat[data-cat]');
  var focoAnterior = null;

  function abreMenu(de, modo) {
    focoAnterior = de;
    // o mesmo painel serve para coleções, caixa e busca: só muda o miolo
    menu.classList.toggle('menu--caixa', modo === 'caixa');
    menu.classList.toggle('menu--busca', modo === 'busca');
    var mc = document.getElementById('menuCaixa');
    if (mc) mc.hidden = modo !== 'caixa';
    var mb = document.getElementById('menuBusca');
    if (mb) mb.hidden = modo !== 'busca';
    menu.classList.add('on');
    menu.removeAttribute('inert'); menu.removeAttribute('aria-hidden');
    if (ONM.foco) ONM.foco.prende(menu);
    ONM.trava(true); document.body.classList.add('menuon');
    burgs.forEach(function (b) { b.classList.add('x'); b.setAttribute('aria-expanded', 'true'); });
    if (!largo()) cats.forEach(function (c) { c.classList.remove('on'); });
    animarMarca(true);
    if (ONM.painel && ONM.painel.rato) ONM.painel.rato(true);
    var p = $('.cat__t', menu); if (p) p.focus({ preventScroll: true });
  }
  function fechaMenu() {
    menu.classList.remove('on', 'menu--caixa', 'menu--busca');
    if (ONM.foco) ONM.foco.solta(menu);
    ONM.trava(false); document.body.classList.remove('menuon');
    // inerte só depois da transição, senão o foco que volta ao botão some no meio
    setTimeout(function () { if (!menu.classList.contains('on')) { menu.setAttribute('inert', ''); menu.setAttribute('aria-hidden', 'true'); } }, 300);
    burgs.forEach(function (b) { b.classList.remove('x'); b.setAttribute('aria-expanded', 'false'); });
    if (!largo()) cats.forEach(function (c) { c.classList.remove('on'); });
    animarMarca(false);
    if (ONM.painel && ONM.painel.rato) ONM.painel.rato(false);
    if (focoAnterior) focoAnterior.focus({ preventScroll: true });
  }
  if (menu) {
    burgs.forEach(function (b) {
      b.addEventListener('click', function () {
        // com o painel aberto o botão é um X, seja o que estiver dentro
        // (menu, caixa ou busca): X fecha. Fechado, abre o menu.
        if (menu.classList.contains('on')) return fechaMenu();
        abreMenu(b, 'menu');
      });
    });
    // o bloco da caixa usa isto para abrir o mesmo painel com o carrinho
    window.ONM = window.ONM || {};
    ONM.painel = {
      abre: function (modo) { abreMenu(null, modo); },
      fecha: fechaMenu,
      aberto: function () { return menu.classList.contains('on'); }
    };
    // fechar: o X do topo e a área fora do painel, no desktop
    $$('#burgCloseBar, #burgCloseTop, [data-menu-fora]').forEach(function (b) {
      b.addEventListener('click', fechaMenu);
    });

    // direção recente do mouse, para o menu do desktop
    var trocaTimer = null, ratoX = 0, ratoY = 0, ratoDX = 0, ratoDY = 0;
    // o rastreio do mouse só é ligado enquanto o painel está aberto no
    // desktop: antes rodava em toda página, o tempo todo
    var rato = function (e) {
      ratoDX = e.clientX - ratoX; ratoDY = e.clientY - ratoY;
      ratoX = e.clientX; ratoY = e.clientY;
    };
    ONM.painel.rato = function (liga) {
      if (liga && largo()) document.addEventListener('mousemove', rato, { passive: true });
      else document.removeEventListener('mousemove', rato);
    };
    cats.forEach(function (c) {
      var t = $('.cat__t', c);
      if (t && t.tagName === 'BUTTON') {
        t.addEventListener('click', function () {
          var era = c.classList.contains('on');
          cats.forEach(function (o) { o.classList.remove('on'); });
          if (largo() || !era) c.classList.add('on');
        });
        if (largo()) t.addEventListener('mouseenter', function () {
          // Quem sai de "Banheiro" em direção às opções da direita passa
          // pelos títulos de baixo no caminho. Se o mouse está indo mais
          // para a direita do que para baixo, espera um pouco: quem só
          // atravessa some do título antes do prazo e nada muda; quem
          // parou ali quer trocar mesmo, e troca.
          clearTimeout(trocaTimer);
          var indoParaDireita = ratoDX > 2 && ratoDX > Math.abs(ratoDY) * 0.8;
          var troca = function () {
            cats.forEach(function (o) { o.classList.remove('on'); });
            c.classList.add('on');
          };
          if (indoParaDireita && $('.cat.on')) trocaTimer = setTimeout(troca, 260);
          else troca();
        });
        if (largo()) t.addEventListener('mouseleave', function () { clearTimeout(trocaTimer); });
      }
      $$('.sub__t', c).forEach(function (bt) {
        bt.addEventListener('click', function () {
          var g = bt.parentElement, era = g.classList.contains('on');
          $$('.grupo', c).forEach(function (o) { o.classList.remove('on'); });
          if (!era) g.classList.add('on');
        });
      });
      var back = $('.cat__back', c);
      if (back) back.addEventListener('click', function () {
        c.classList.remove('on');
        var t2 = $('.cat__t', c); if (t2) t2.focus({ preventScroll: true });
      });
    });
    if (!largo()) cats.forEach(function (c) { c.classList.remove('on'); });
  }

  /* ── janela lateral das tags e tecnologias ────────────────────── */
  var sheet = $('#onmSheet');
  if (sheet) {
    var dentro = $('#onmSheetIn'), voltaFoco = null;
    var abreSheet = function (id, de) {
      var tpl = $('[data-conteudo="' + id + '"]'); if (!tpl) return;
      voltaFoco = de;
      dentro.innerHTML = tpl.innerHTML;
      // com um campo de texto dentro, no celular a janela vem pelo topo:
      // ancorada embaixo, o teclado a cobria inteira
      sheet.classList.toggle('sheet--form', !!$('input', dentro));
      sheet.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('on'); });
      ONM.trava(true);
      if (ONM.foco) ONM.foco.prende(sheet);
      // o conteúdo acabou de nascer: o frete da gaveta vive aqui e precisa
      // dos ouvintes do CEP (o cupom usa ouvintes no documento e não precisa)
      if (window.ONM && ONM.ligaCep) ONM.ligaCep();
      var primeiro = $('input', dentro);
      if (primeiro) primeiro.focus({ preventScroll: true });
      else $('.sheet__x', sheet).focus({ preventScroll: true });
    };
    var fechaSheet = function () {
      if (sheet.hidden) return;
      sheet.classList.remove('on');
      ONM.trava(false);
      if (ONM.foco) ONM.foco.solta(sheet);
      setTimeout(function () { sheet.hidden = true; dentro.innerHTML = ''; }, 340);   // limpa: um [data-cep] velho enganava a cotação
      if (voltaFoco) voltaFoco.focus({ preventScroll: true });
    };
    $$('[data-fecha]', sheet).forEach(function (e) { e.addEventListener('click', fechaSheet); });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-janela]'); if (!b) return;
      abreSheet(b.dataset.janela, b);
    });
    sheet._fecha = fechaSheet;
    window.ONM = window.ONM || {};
    ONM.abreSheet = abreSheet;
    ONM.fechaSheet = fechaSheet;
  }

  /* ── acordeões ────────────────────────────────────────────────── */
  $$('.acc .acc__t').forEach(function (b) {
    b.addEventListener('click', function () {
      var a = b.closest('.acc'), era = a.classList.contains('open');
      a.classList.toggle('open', !era);
      b.setAttribute('aria-expanded', String(!era));
    });
  });
  // link que aponta para dentro de um acordeão abre o acordeão, não só rola
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var alvo = document.getElementById(id);
    if (!alvo) return;
    var acc = alvo.classList.contains('acc') ? alvo : alvo.closest('.acc');
    if (!acc) return;
    e.preventDefault();
    if (!acc.classList.contains('open')) {
      acc.classList.add('open');
      var bt = acc.querySelector('.acc__t');
      if (bt) bt.setAttribute('aria-expanded', 'true');
      // widgets de terceiros medem a área quando ela deixa de ter altura zero
      setTimeout(function () {
        dispatchEvent(new Event('resize'));
        document.dispatchEvent(new CustomEvent('onm:abriu', { detail: { id: acc.id } }));
      }, 360);
    }
    setTimeout(function () {
      acc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    }, 60);
  });

  $$('.qa > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = b.parentElement, era = q.classList.contains('open');
      var irmaos = q.parentElement.querySelectorAll('.qa');
      Array.prototype.forEach.call(irmaos, function (o) {
        o.classList.remove('open');
        var bo = o.querySelector('button');
        if (bo) bo.setAttribute('aria-expanded', 'false');
      });
      if (!era) { q.classList.add('open'); b.setAttribute('aria-expanded', 'true'); }
    });
  });

  /* ── cores nos cartões ────────────────────────────────────────────
     A bolinha troca a foto, o nome e o preço ali mesmo. O cartão inteiro
     passa a apontar para a cor escolhida, então o clique na imagem abre o
     produto certo. Vale também para cartões que chegam depois, do filtro
     ou dos complementares, porque o clique é ouvido no documento.
     ─────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.card__sw .sw') : null;
    if (!sw || !sw.dataset.img || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var card = sw.closest('.card');
    if (!card) return;
    var img = card.querySelector('.card__f img');
    if (img) {
      img.src = sw.dataset.img;
      if (sw.dataset.set) img.srcset = sw.dataset.set;
      if (sw.dataset.alt) img.alt = sw.dataset.alt;
    }
    var nome = card.querySelector('h3 a');
    if (nome && sw.dataset.nome) nome.textContent = sw.dataset.nome;
    var preco = card.querySelector('.card__p');
    if (preco && sw.dataset.preco) preco.innerHTML = sw.dataset.preco;
    card.querySelectorAll('.card__f, h3 a').forEach(function (a) { a.href = sw.href; });
    card.querySelectorAll('.card__sw .sw').forEach(function (o) {
      o.classList.toggle('on', o === sw);
      if (o === sw) { o.setAttribute('aria-current', 'true'); } else { o.removeAttribute('aria-current'); }
    });
  });

  /* ── Escape fecha o que estiver aberto ────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var filtros = document.getElementById('onmFiltros');   // vive no onm-colecao.js
    if (filtros && filtros.classList.contains('on') && filtros._fecha) return filtros._fecha();
    if (sheet && sheet.classList.contains('on')) return sheet._fecha();
    var sub = !largo() && $('.cat.on');
    if (sub) return sub.classList.remove('on');
    if (menu && menu.classList.contains('on')) fechaMenu();
  });
})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }

/* ══ Avisos, campanha, frete, complementares e estrelas ═══════════ */
try {
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // barra de avisos: troca a mensagem a cada 4 segundos
  var av = document.querySelector('[data-aviso]');
  if (av) {
    var msgs = av.querySelectorAll('.aviso__m');
    if (msgs.length > 1) {
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('on');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('on');
      }, 4000);
    }
  }


  // ── frete por CEP ─────────────────────────────────────────────
  // 1) ViaCEP descobre o estado; 2) a região dá o prazo e o frete grátis;
  // 3) se o app Dr Cart estiver na página, o tema alimenta o widget dele,
  //    escondido, e lê as taxas reais; 4) o CEP e o estado seguem para o
  //    checkout já preenchidos.
  var ultimoCep = null;                          // o que o botão de checkout usa

  /* ── frete: um estado só, para a janela e para a linha do resumo ────
     A cotação é uma: ViaCEP para cidade e UF, depois o Dr Cart para as
     transportadoras, das quais ficam a mais barata (Econômico) e a mais
     rápida (Expresso), como o tema antigo fazia. O resultado é desenhado
     em todo lugar que exista naquele momento: a resposta dentro da
     janela de frete e a linha "Frete" do resumo. Com um CEP lembrado, a
     cotação roda sozinha assim que a gaveta ou a página do carrinho
     carregam, para a linha já nascer com valor. */
  var din = function (c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
  var cfgCep = function () { return $('[data-frete-cfg]') || $('[data-cep]'); };   // o resumo tem o total atual; o da janela é o do carregamento
  // quantas regiões o resumo trouxe (data-r1, data-r2…): a última, sem lista
  // de estados que combine, vale para o resto do país
  var nRegioes = function (cfg) { var n = 1; while (cfg.dataset['r' + (n + 1)] !== undefined) n++; return n; };
  var regiaoDe = function (cfg, uf) {
    var n = nRegioes(cfg);
    for (var i = 1; i < n; i++) if ((cfg.dataset['e' + i] || '').split(',').map(function (x) { return x.trim(); }).indexOf(uf) >= 0) return i;
    return n;
  };
  // sem CEP digitado, o estado pela internet do visitante (onm_geo, que a
  // ficha do produto guarda por 7 dias) escolhe a região da barra
  var ufGeo = function () {
    try { var g = JSON.parse(localStorage.getItem('onm_geo') || 'null'); return (g && g.uf && g.t > Date.now() - 7 * 864e5) ? g.uf : ''; } catch (e) { return ''; }
  };
  var ICONE = {
    eco: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 3h2a2 2 0 0 1 2 2v6h-4V3zM3 7h13v8H3zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM8 17h8M16 11h4"/></svg>',
    exp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 3 14h8l-1 8 10-12h-8l1-8z"/></svg>'
  };
  var lerDrCart = function () {
    var root = $('[data-drcart]'); if (!root) return null;
    var nodes = $$('.docapp-shipping-rate', root); if (!nodes.length) return null;
    var out = [];
    nodes.forEach(function (n, i) {
      // O app monta as linhas aos poucos. Uma linha só conta quando está
      // inteira: com o radio, com o nome e com um preço legível. Linha
      // pela metade (sem preço ainda) não entra, nunca vira "grátis".
      var radio = n.querySelector('input[type="radio"]'); if (!radio) return;
      var rotulo = ((n.querySelector('.docapp-shipping-rate-name label') || n).textContent || '').replace(/\s+/g, ' ').trim();
      if (!rotulo) return;
      var precoTxt = ((n.querySelector('.docapp-shipping-rate-price') || {}).textContent || '').replace(/\s+/g, ' ').trim();
      var gratisTxt = /gr[áa]tis|free/i.test(precoTxt) || /^R?\$?\s*0[,.]00$/.test(precoTxt);
      var cents = parseInt(radio.value, 10);
      if (isNaN(cents) || (cents === 0 && !gratisTxt)) {
        var pt = precoTxt.replace(/[^\d,]/g, '').replace(',', '.');
        cents = pt ? Math.round(parseFloat(pt) * 100) : NaN;
      }
      if (gratisTxt) cents = 0;
      if (isNaN(cents) || (cents === 0 && !gratisTxt)) return;   // sem preço: ainda não é uma taxa
      var dmin = 0, dias = '';
      var faixa = rotulo.match(/\((\d+)\s*a\s*(\d+)\s*dias?\s*[úu]teis?\)/i);
      var um = rotulo.match(/\((\d+)\s*dias?\s*[úu]teis?\)/i);
      if (faixa) { dmin = +faixa[1]; dias = dmin + ' a ' + (+faixa[2]) + ' dias úteis'; }
      else if (um) { dmin = +um[1]; dias = dmin + (dmin === 1 ? ' dia útil' : ' dias úteis'); }
      out.push({ i: i, dias: dias, dmin: dmin, cents: cents, gratis: cents === 0 });
    });
    return out.length ? out : null;
  };
  var escolhe = function (rates) {
    if (!rates.length) return [];
    var batiza = function (r) {
      var d = r.dmin || 0;
      if (d > 0 && d <= 3) return Object.assign({}, r, { tipo: 'exp', nome: 'Envio expresso' });
      if (d > 0 && d <= 7) return Object.assign({}, r, { tipo: 'eco', nome: 'Envio rápido' });
      return Object.assign({}, r, { tipo: 'eco', nome: 'Envio' });
    };
    if (rates.length === 1) return [batiza(rates[0])];
    var barato = rates.slice().sort(function (a, b) { return a.cents - b.cents || (a.dmin || 999) - (b.dmin || 999); })[0];
    var rapido = rates.slice().sort(function (a, b) { return (a.dmin || 999) - (b.dmin || 999) || a.cents - b.cents; })[0];
    if (barato.i === rapido.i) return [batiza(barato)];
    return [Object.assign({}, barato, { tipo: 'eco', nome: 'Econômico' }), Object.assign({}, rapido, { tipo: 'exp', nome: 'Expresso' })];
  };

  var estado = null;      // { cep, cidade, uf, prazo, rates: null | [] , erro }
  /* a barra do frete grátis: região do CEP calculado; sem CEP, a do estado
     pela internet; sem nenhum dos dois, a região 1 */
  var desenhaBarra = function () {
    $$('[data-fretebar]').forEach(function (bar) {
      var cfg = bar.closest('[data-frete-cfg]'); if (!cfg) return;
      var total = parseInt(cfg.dataset.total, 10) || 0;
      var uf = (estado && !estado.erro && estado.uf) ? estado.uf : ufGeo();
      var r = uf ? regiaoDe(cfg, uf) : 1;
      var piso = parseInt(cfg.dataset['r' + r], 10) || 0;
      var nome = cfg.dataset['n' + r] || '';
      if (!piso) { bar.hidden = true; return; }
      var t, pct = Math.min(100, Math.round(total / piso * 100)), ok = false;
      if (!uf) {
        // sem CEP nem estado: diz para onde o total já tem frete grátis,
        // pelas siglas (os nomes das regiões têm "e" no meio e a lista
        // ficaria confusa); passando o piso da última região, é o Brasil
        // todo; abaixo da primeira, diz quanto falta para ela
        var nr = nRegioes(cfg), ufs = [], todas = true;
        for (var k = 1; k <= nr; k++) {
          var pk = parseInt(cfg.dataset['r' + k], 10) || 0;
          if (!pk || total < pk) { todas = false; continue; }
          if (k < nr) (cfg.dataset['e' + k] || '').split(',').forEach(function (x) { if (x.trim()) ufs.push(x.trim()); });
        }
        if (todas) { ok = true; pct = 100; t = 'Frete grátis para todo o Brasil'; }
        else if (ufs.length) {
          ok = true; pct = 100;
          var lista = ufs.length === 1 ? ufs[0] : ufs.slice(0, -1).join(', ') + ' e ' + ufs[ufs.length - 1];
          t = (bar.dataset.tOk || 'Frete grátis para [regiao]').replace('[regiao]', lista);
        } else {
          t = (bar.dataset.tFalta || '').replace('[valor]', din(piso - total)).replace('[regiao]', nome);
        }
      }
      else if (total >= piso) { ok = true; t = (bar.dataset.tOk || '').replace('[regiao]', nome); }
      else t = (bar.dataset.tFalta || '').replace('[valor]', din(piso - total)).replace('[regiao]', nome);
      var tx = bar.querySelector('[data-fretebar-txt]'); if (tx) tx.textContent = t;
      var fill = bar.querySelector('[data-fretebar-fill]'); if (fill) fill.style.width = pct + '%';
      bar.classList.toggle('fretebar--ok', ok);
      bar.hidden = !t;
    });
  };
  /* o total do resumo passa a somar o frete mais barato do CEP calculado
     (o desconto do Pix vale só sobre os produtos; o frete entra inteiro
     nos dois). Sem CEP ou com erro, volta ao valor do servidor. */
  var desenhaTotal = function () {
    var e = estado;
    $$('[data-frete-cfg]').forEach(function (cfg) {
      var tp = cfg.querySelector('[data-total-pix]'), tou = cfg.querySelector('[data-total-ou]');
      if (!tp || !tou) return;
      if (!tp.dataset.orig) { tp.dataset.orig = tp.textContent; tou.dataset.orig = tou.textContent; }
      var frete = 0, temFrete = false;
      if (e && !e.erro && e.uf && e.rates && e.rates.length) { temFrete = true; frete = e.rates[0].gratis ? 0 : (e.rates[0].cents || 0); }
      if (!temFrete) { tp.textContent = tp.dataset.orig; tou.textContent = tou.dataset.orig; return; }
      var pr = (window.ONM && ONM.preco) || { pix: 0, pmax: 12, pmin: 15000 };
      var total = parseInt(cfg.dataset.total, 10) || 0;
      var pix = pr.pix > 0 ? Math.floor(total * (100 - pr.pix) / 100) : total;
      var cartao = total + frete;
      var n = Math.max(1, Math.min(pr.pmax || 12, Math.floor(cartao / (pr.pmin || 15000))));
      tp.textContent = din(pix + frete);
      tou.textContent = n > 1 ? din(cartao) + ' em ' + n + 'x ' + din(Math.floor(cartao / n)) + ' sem juros' : din(cartao) + ' no cartão';
    });
  };
  var desenha = function () {
    var e = estado;
    desenhaBarra();
    desenhaTotal();
    // a linha do resumo, onde existir
    $$('[data-frete-valor]').forEach(function (v) {
      var cepEl = v.parentNode.querySelector('[data-frete-cep]');
      if (!e || e.erro) { v.textContent = 'Calcular'; if (cepEl) cepEl.textContent = ''; return; }
      if (cepEl) cepEl.textContent = e.cep.slice(0, 5) + '-' + e.cep.slice(5);
      if (e.rates === null) { v.textContent = 'Calculando…'; return; }
      if (!e.rates.length) { v.textContent = e.prazo || 'A confirmar'; return; }
      var barato = e.rates[0];
      v.textContent = barato.gratis ? 'Grátis' : din(barato.cents);
    });
    // a resposta dentro da janela, se estiver aberta
    $$('[data-cep-resposta]').forEach(function (res) {
      if (!e) { res.hidden = true; return; }
      var h;
      if (e.erro) h = '<p class="cep__erro">' + esc(e.erro) + '</p>';
      else {
        h = '<p class="cep__loc">Entrega para <b>' + esc(e.cidade) + ', ' + esc(e.uf) + '</b></p>';
        if (e.rates === null) h += '<p class="cep__aguarda">Calculando as opções de entrega…</p>';
        else if (e.rates.length) {
          h += '<div class="cep__ops">' + e.rates.map(function (r) {
            return '<div class="cep__op cep__op--' + r.tipo + '"><i>' + ICONE[r.tipo] + '</i>' +
              '<span class="cep__op-l"><b>' + esc(r.nome) + '</b><small>' + (r.dias || 'prazo confirmado no checkout') + '</small></span>' +
              (r.gratis ? '<em class="cep__op-p cep__op-p--gratis">Grátis</em>' : '<em class="cep__op-p">' + din(r.cents) + '</em>') + '</div>';
          }).join('') + '</div>';
        } else if (e.prazo) h += '<p class="cep__loc">Prazo estimado: ' + esc(e.prazo) + '</p>';
      }
      res.innerHTML = h; res.hidden = false;
    });
  };
  var cotarDrCart = function (c, uf) {
    var meu = estado;
    var root = $('[data-drcart]'); if (!root) { meu.rates = []; desenha(); return; }
    var zip = root.querySelector('input[name="shipping_address[zip]"]'), prov = root.querySelector('select[name="shipping_address[province]"]');
    var btn = root.querySelector('.docapp-shipping-calculator--button');
    if (!zip || !btn) { meu.rates = []; desenha(); return; }
    zip.value = c; zip.dispatchEvent(new Event('input', { bubbles: true }));
    if (prov) { for (var i = 0; i < prov.options.length; i++) if (prov.options[i].value === uf || prov.options[i].text === uf) prov.selectedIndex = i; prov.dispatchEvent(new Event('change', { bubbles: true })); }
    var assina = function (rates) { return rates ? JSON.stringify(rates.map(function (r) { return [r.i, r.cents, r.dias]; })) : ''; };
    var antes = assina(lerDrCart());                 // o que o widget mostrava do CEP anterior
    btn.click();
    var tenta = 0, anterior = '', t = setInterval(function () {
      var rates = lerDrCart(); tenta++;
      if (estado !== meu) { clearInterval(t); return; }          // veio outro CEP no meio
      // O app monta a lista aos poucos, e por um instante ainda mostra a
      // lista do CEP anterior. Só aceitamos quando duas leituras seguidas
      // coincidem E a lista já é outra; se em 3 segundos continuar igual à
      // anterior, é porque as taxas são as mesmas mesmo.
      var agora = assina(rates);
      var estavel = rates && agora === anterior;
      if (estavel && (agora !== antes || tenta > 6)) { clearInterval(t); meu.rates = escolhe(rates); desenha(); return; }
      anterior = agora;
      if (tenta > 24) { clearInterval(t); meu.rates = rates ? escolhe(rates) : []; desenha(); }
    }, 500);
  };
  var cotando = null;
  var cotar = function (c, depois) {
    var cfg = cfgCep(); if (!cfg) return;
    // a cotação vale para o carrinho em que foi feita: mudou o total (item
    // a mais, quantidade, cupom), cota de novo, porque frete grátis e
    // valor dependem do que está na caixa
    var totalAgora = cfg.dataset.total || '';
    if (estado && estado.cep === c && !estado.erro && estado.rates !== null && estado.total === totalAgora) { desenha(); if (depois) depois(true); return; }
    if (cotando === c + '|' + totalAgora) return;
    cotando = c + '|' + totalAgora;
    estado = { cep: c, cidade: '', uf: '', prazo: '', rates: null, total: totalAgora };
    $$('[data-cep-resposta]').forEach(function (r) { r.innerHTML = '<p class="cep__aguarda">Consultando…</p>'; r.hidden = false; });
    $$('[data-frete-valor]').forEach(function (v) { v.textContent = 'Calculando…'; });
    var ctl = window.AbortController ? new AbortController() : null;
    var relogio = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : null;
    fetch('https://viacep.com.br/ws/' + c + '/json/', ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
      if (relogio) clearTimeout(relogio);
      cotando = null;
      if (!d || d.erro) { estado = { cep: c, erro: 'CEP não encontrado.', rates: [], total: totalAgora }; desenha(); if (depois) depois(false); return; }
      var uf = d.uf, r = regiaoDe(cfg, uf);
      ultimoCep = { cep: c, uf: uf, cidade: d.localidade };
      try { localStorage.setItem('onm_cep', JSON.stringify(ultimoCep)); } catch (e) {}
      estado = { cep: c, cidade: d.localidade, uf: uf, prazo: cfg.dataset['p' + r] || '', rates: null, total: totalAgora };
      desenha();
      cotarDrCart(c, uf);
      if (depois) depois(true);
    }).catch(function () {
      if (relogio) clearTimeout(relogio);
      cotando = null;
      estado = { cep: c, erro: 'Não deu para consultar agora. Tente de novo.', rates: [], total: totalAgora }; desenha(); if (depois) depois(false);
    });
  };
  var lembrado = function () { try { var l = JSON.parse(localStorage.getItem('onm_cep') || 'null'); return l && l.cep ? l.cep : null; } catch (e) { return null; } };

  function ligaCep() {
    // a caixa de CEP (dentro da janela): liga uma vez cada
    $$('[data-cep]').forEach(function (cep) {
      if (cep.dataset.ligado) return;
      cep.dataset.ligado = '1';
      var inp = cep.querySelector('[data-cep-campo]'), go = cep.querySelector('[data-cep-vai]');
      if (!inp || !go) return;
      var calcula = function () {
        var c = (inp.value || '').replace(/\D/g, '');
        if (c.length !== 8) { estado = { cep: c, erro: 'Digite o CEP com 8 números.', rates: [] }; desenha(); return; }
        go.disabled = true;
        cotar(c, function () { go.disabled = false; });
      };
      go.addEventListener('click', calcula);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcula(); } });
      inp.addEventListener('input', function () { var v = inp.value.replace(/\D/g, '').slice(0, 8); inp.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
      var l = lembrado();
      if (l) { inp.value = l.slice(0, 5) + '-' + l.slice(5); cotar(l); }
      else if (estado) desenha();
    });
    // a linha do resumo: com CEP lembrado, cota sozinha; sem, mostra "Calcular"
    if ($('[data-frete-valor]')) {
      var l2 = lembrado();
      if (l2) cotar(l2); else desenha();
    } else desenhaBarra();
  }

  // checkout com CEP e estado já preenchidos, valendo o último CEP
  // calculado. O ouvinte fica no documento e reconhece pelo
  // name="checkout": vale pro botão do resumo e pro botão do dock (o do
  // app de Pix não tem esse name, de propósito). Antes de redirecionar,
  // qualquer quantidade digitada à mão no carrinho é gravada, para o
  // checkout abrir com a caixa exatamente como a pessoa deixou.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!b || !ultimoCep) return;
    var destino = '/checkout?checkout[shipping_address][country]=BR&checkout[shipping_address][zip]=' +
      encodeURIComponent(ultimoCep.cep) + '&checkout[shipping_address][province]=' + encodeURIComponent(ultimoCep.uf) +
      '&checkout[shipping_address][city]=' + encodeURIComponent(ultimoCep.cidade || '');
    var form = b.form;
    var campos = form ? Array.prototype.slice.call(form.querySelectorAll('input[name="updates[]"]')) : [];
    var mudados = campos.filter(function (i) {
      var v = String(i.value).trim();
      return v !== '' && v !== i.defaultValue;
    });
    e.preventDefault();
    if (!mudados.length) { location.href = destino; return; }
    var updates = campos.map(function (i) {
      var v = String(i.value).trim();
      return v === '' ? Math.max(0, parseInt(i.defaultValue, 10) || 0) : Math.max(0, parseInt(v, 10) || 0);
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { if (!r.ok) throw 0; location.href = destino; })
      .catch(function () {
        // sem rede pra gravar: segue o caminho nativo do formulário, que
        // grava as quantidades (perde só o CEP preenchido)
        if (form && form.requestSubmit) form.requestSubmit(b);
        else if (form) form.submit();
        else location.href = destino;
      });
  });
  ligaCep();
  window.ONM = window.ONM || {};
  ONM.ligaCep = ligaCep;   // a caixa chama isto depois de montar o conteúdo

  /* ── cupom ───────────────────────────────────────────────────────
     O mesmo caminho do tema antigo: POST /cart/update.js com o código,
     conferência no /cart.js (o cupom só vale se aparecer aplicado), e
     como reserva a rota /discount/CÓDIGO, que grava o cupom para o
     checkout e recarrega. Na gaveta o resultado é redesenhado pelo
     servidor; na página do carrinho a página recarrega, porque o resumo
     dela nasce no Liquid. Os ouvintes ficam no documento, então valem
     para a gaveta que chega depois. */
  var cupomMsg = function (cx, t, some) {
    var m = cx && cx.querySelector('[data-cupom-msg]'); if (!m) return;
    m.textContent = t; m.hidden = !t;
    if (some) setTimeout(function () { m.hidden = true; }, 4000);
  };
  var cupomDepois = function () {
    var dentro = document.getElementById('menuCaixa');
    if (window.ONM && ONM.fechaSheet) ONM.fechaSheet();
    if (dentro && !dentro.hidden && dentro.childElementCount && window.ONM && ONM.carregaCaixa) { ONM.carregaCaixa(); return; }
    location.reload();
  };
  document.addEventListener('click', function (e) {
    var vai = e.target.closest && e.target.closest('[data-cupom-vai]');
    var rm = e.target.closest && e.target.closest('[data-cupom-rm]');
    if (!vai && !rm) return;
    e.preventDefault();
    if (rm) {
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) })
        .then(cupomDepois, cupomDepois);
      return;
    }
    var cx = vai.closest('[data-cupom]'); if (!cx) return;
    var inp = cx.querySelector('[data-cupom-campo]');
    var code = ((inp && inp.value) || '').trim();
    if (!code) { cupomMsg(cx, 'Digite o código do cupom.', true); return; }
    vai.disabled = true; cupomMsg(cx, 'Aplicando…');
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { if (!r.ok) throw 'sem-api'; return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var apps = (c && c.cart_level_discount_applications) || [];
        var codes = (c && c.discount_codes) || [];
        var ok = apps.some(function (a) { return String(a.title || '').toUpperCase() === code.toUpperCase(); }) ||
                 codes.some(function (d) { return String(d.code || '').toUpperCase() === code.toUpperCase() && d.applicable !== false; });
        if (!ok) throw 0;
        cupomMsg(cx, 'Cupom aplicado.');
        setTimeout(cupomDepois, 300);
      })
      .catch(function (semApi) {
        vai.disabled = false;
        if (semApi === 'sem-api') {
          // a loja não aceitou o cupom pela API: a rota /discount grava o
          // código para o checkout e volta para onde a pessoa estava
          location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(location.pathname);
          return;
        }
        cupomMsg(cx, 'Cupom não reconhecido. Confira o código.', true);
      });
  });

  // ── complementares: o Shopify sugere o que costuma ir junto ─────
  // O desenho vem pronto da seção 'complementares', então o cartão sai
  // igual ao da coleção, com cor, título, preço e nota.
  var compl = document.getElementById('complementares');
  if (compl && compl.dataset.produto) {
    fetch('/recommendations/products?section_id=complementares&product_id=' +
      encodeURIComponent(compl.dataset.produto) + '&limit=4&intent=complementary')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.card');
        if (!cards.length) return;
        var lista = document.getElementById('complLista');
        Array.prototype.forEach.call(cards, function (c) { lista.appendChild(c); });
        compl.hidden = false;
        document.dispatchEvent(new CustomEvent('onm:cards'));   // pinta as notas
      }).catch(function () {});
  }

  // ── estrelas dos cartões ────────────────────────────────────────
  // O cartão já nasce com a estrela vazia, então a linha da nota existe
  // sempre. Quando a Konfidency responde, a estrela acende e o número
  // entra. Cartões que chegam depois (complementares, filtro) avisam
  // pelo evento onm:cards e entram na mesma leva.
  /* cache curto no navegador (1 h) para não bater na Konfidency a cada
     página: a mesma pessoa passa por várias coleções e pela home na
     mesma visita, e a nota não muda de um minuto pro outro */
  var TTL = 3600e3;
  var cacheLe = function (k) {
    try { var c = JSON.parse(localStorage.getItem('onm_kf_' + k) || 'null'); return c && (Date.now() - c.t) < TTL ? c.d : null; } catch (e) { return null; }
  };
  var cacheGrava = function (k, d) { try { localStorage.setItem('onm_kf_' + k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} };
  function pintaNotas(escopo) {
    var alvos = $$('[data-nota-sku]', escopo || document).filter(function (e) { return !e.dataset.notaFeita; });
    if (!alvos.length || !window.ONM || !ONM.konf || !ONM.konf.loja) return;
    alvos.forEach(function (e) { e.dataset.notaFeita = '1'; });

    var candsDe = function (e) {
      return [e.dataset.notaSku].concat((e.dataset.notaAlt || '').split('|'))
        .map(function (c) { return (c || '').trim(); })
        .filter(function (c, i, a) { return c && a.indexOf(c) === i; });
    };
    var todos = [];
    alvos.forEach(function (e) { candsDe(e).forEach(function (c) { if (todos.indexOf(c) < 0) todos.push(c); }); });
    var hosts = [(ONM.konf.api || '').replace(/\/+$/, ''), 'https://reviews-api.konfidency.com.br']
      .filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    var tenta = function (i) {
      if (i >= hosts.length) return Promise.resolve(null);
      return fetch(hosts[i] + '/' + encodeURIComponent(ONM.konf.loja) + '/ratings?skus=' + encodeURIComponent(todos.join(',')), { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .catch(function () { return tenta(i + 1); });
    };
    var chaveNotas = 'notas_' + todos.join(',');
    var guardado = cacheLe(chaveNotas);
    (guardado ? Promise.resolve(guardado) : tenta(0).then(function (d) { if (d) cacheGrava(chaveNotas, d); return d; }))
      .then(function (d) {
        if (!d) return;
        var itens = Array.isArray(d) ? d : (d.ratings || d.skus || d.items || d.results || []);
        var mapa = {};
        itens.forEach(function (it) {
          var sku = it.sku || it.id, qtd = it.reviewCount || it.totalReviews || it.count || it.total || 0;
          var nota = it.aggregateRating || it.rating || it.average || (it.sumRatings && qtd ? it.sumRatings / qtd : 0);
          if (sku && qtd > 0 && nota) mapa[String(sku)] = { nota: nota, qtd: qtd };
        });
        alvos.forEach(function (e) {
          var hit = null;
          candsDe(e).forEach(function (c) { if (!hit && mapa[c]) hit = mapa[c]; });
          if (!hit) return;                                  // sem avaliação: fica a estrela vazia
          e.querySelector('b').textContent = Number(hit.nota).toFixed(1).replace('.', ',');
          e.querySelector('em').textContent = '(' + Number(hit.qtd).toLocaleString('pt-BR') + ')';
          e.classList.remove('card__r--vazia');
        });
      }).catch(function () {});
  }
  pintaNotas();
  document.addEventListener('onm:cards', function () { pintaNotas(); });
})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }

/* ══ Depoimentos da home ═══════════════════════════════════════════
   Busca na Konfidency as avaliações mais recentes que têm foto, entre
   os produtos da coleção escolhida na seção, e troca os depoimentos
   fixos por elas. A foto que o cliente mandou vira o avatar, redondo,
   sem abrir nada: é ali só para mostrar o móvel instalado de verdade.
   Se a API não responder, os depoimentos do editor continuam no ar.
   ═══════════════════════════════════════════════════════════════ */
try {
(function () {
  'use strict';
  var caixa = document.getElementById('depoHome');
  if (!caixa) return;
  var loja = caixa.dataset.loja;
  var skus = (caixa.dataset.skus || '').split(',').filter(Boolean);
  var quantos = parseInt(caixa.dataset.qtd, 10) || 3;
  if (!loja || !skus.length) return;

  var hosts = [(caixa.dataset.api || '').replace(/\/+$/, ''), 'https://reviews-api.konfidency.com.br']
    .filter(function (h, i, a) { return h && a.indexOf(h) === i; });

  var esc = function (t) {
    var d = document.createElement('div'); d.textContent = t == null ? '' : t;
    return d.innerHTML;
  };
  var quando = function (iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var dias = Math.round((Date.now() - d) / 864e5);
    if (dias < 30) return 'há ' + Math.max(1, dias) + (dias <= 1 ? ' dia' : ' dias');
    var m = Math.round(dias / 30);
    if (m < 12) return 'há ' + m + (m === 1 ? ' mês' : ' meses');
    var a = Math.round(m / 12);
    return 'há ' + a + (a === 1 ? ' ano' : ' anos');
  };
  var estrelas = function (n) {
    var s = '';
    for (var i = 1; i <= 5; i++) {
      s += '<svg viewBox="0 0 24 24" class="st"' + (i > n ? ' style="opacity:.22"' : '') +
        ' aria-hidden="true"><path d="m12 2 3 6.5 7 .9-5 4.8 1.3 6.8L12 17.8 5.7 21l1.3-6.8-5-4.8 7-.9L12 2Z"/></svg>';
    }
    return '<div class="rev__s">' + s + '</div>';
  };
  var primeiroNome = function (n) {
    var p = (n || 'Cliente').trim().split(/\s+/);
    if (p.length === 1) return p[0];
    return p[0] + ' ' + p[p.length - 1].charAt(0).toUpperCase() + '.';
  };

  var cartao = function (r) {
    var f = (r.pictures || [])[0] || {};
    var foto = f.thumb || f.url || '';
    var quem = primeiroNome(r.name);
    var avatar = foto
      ? '<span class="rev__av"><img src="' + esc(foto) + '" alt="" loading="lazy" decoding="async"></span>'
      : '<span class="rev__av rev__av--letra">' + esc(quem.charAt(0)) + '</span>';
    var selo = r.verified ? ' · compra verificada' : '';
    return '<article class="rev">' +
      estrelas(r.rating || 5) +
      '<p>' + esc(r.text) + '</p>' +
      '<div class="rev__h rev__h--fim">' +
      '<span class="rev__q">' + avatar + '<b>' + esc(quem) + '</b></span>' +
      '<span>' + quando(r.created) + selo + '</span></div></article>';
  };

  // embaralha os produtos para a vitrine não repetir sempre os mesmos
  var ordem = skus.slice().sort(function () { return Math.random() - 0.5; }).slice(0, 6);

  /* cache curto no navegador (1 h) para não bater na Konfidency a cada
     página: a mesma pessoa passa por várias coleções e pela home na
     mesma visita, e a nota não muda de um minuto pro outro */
  var TTL = 3600e3;
  var cacheLe = function (k) {
    try { var c = JSON.parse(localStorage.getItem('onm_kf_' + k) || 'null'); return c && (Date.now() - c.t) < TTL ? c.d : null; } catch (e) { return null; }
  };
  var cacheGrava = function (k, d) { try { localStorage.setItem('onm_kf_' + k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} };
  function pega(host, sku) {
    var g = cacheLe('depo_' + sku);
    if (g) return Promise.resolve(g);
    return fetch(host + '/' + encodeURIComponent(loja) + '/' + encodeURIComponent(sku) +
      '/summary/created,desc?page=1&pageSize=2&filterMedia=pictures&hasText=true',
      { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var bloco = (Array.isArray(d.reviews) && d.reviews[0] && d.reviews[0].reviews) ? d.reviews[0] : d;
        var lista = bloco.reviews || bloco.results || [];
        cacheGrava('depo_' + sku, lista);
        return lista;
      })
      .catch(function () { return []; });
  }

  function busca(hi) {
    if (hi >= hosts.length) return;
    Promise.all(ordem.map(function (s) { return pega(hosts[hi], s); }))
      .then(function (listas) {
        var todas = [];
        listas.forEach(function (l) { todas = todas.concat(l); });
        todas = todas.filter(function (r) { return r && r.text && (r.pictures || []).length; });
        if (!todas.length) { if (hi + 1 < hosts.length) busca(hi + 1); return; }
        todas.sort(function (a, b) { return new Date(b.created) - new Date(a.created); });
        var vistos = {};
        todas = todas.filter(function (r) {
          // chave reserva quando a API não manda _id: sem ela, todos os
          // depoimentos caíam na mesma chave vazia e só o primeiro ficava
          var k = r._id || ((r.name || '') + '|' + (r.created || '') + '|' + String(r.text || '').slice(0, 40));
          if (vistos[k]) return false; vistos[k] = 1; return true;
        }).slice(0, quantos);
        if (!todas.length) return;
        caixa.innerHTML = todas.map(cartao).join('');
      });
  }

  var dispara = function () { busca(0); };
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { obs.disconnect(); dispara(); }
    }, { rootMargin: '500px' });
    obs.observe(caixa);
  } else { dispara(); }
})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }

/* ══ Capa de tela cheia (home e PDP) ═══════════════════════════════ */
(function () {
  'use strict';
  /* ── capa de tela cheia: vidro no topo e na barra ─────────────── */
  try {
    var heroTela = document.querySelector('.hero-h--tela, .gal--tela');
    if (heroTela) {
      var raizHero = document.documentElement;
      // a capa do produto só existe no celular; a da home vale sempre
      var soCel = heroTela.classList.contains('gal--tela');
      var valeAgora = function () { return !soCel || window.innerWidth < 1000; };
      // com a foto parada (sticky), quem marca o fim da primeira tela é o
      // espaçador, que rola normalmente. Sem ele, a própria capa serve.
      var medidor = document.querySelector('.capaespaco') || heroTela;
      if (heroTela.dataset.vidro === 'preto') raizHero.classList.add('onmCapaPreto');

      /* A página com capa nasce no TOPO, sempre. Em carga nova e em
         recarga, o navegador às vezes "restaurava" uma posição no meio
         da capa, ou um script de aplicativo (os embeds recém-ligados)
         mexia no layout logo após o carregamento e a rolagem descia
         sozinha. Sem âncora no endereço, cravamos o zero duas vezes:
         agora e no quadro seguinte, depois de qualquer reajuste. O
         voltar do navegador (back_forward) fica de fora: restaurar a
         posição ao voltar é o comportamento certo. */
      if (!location.hash) {
        var navEnt = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        var navTipo = navEnt ? navEnt.type : 'navigate';
        if (navTipo === 'navigate' || navTipo === 'reload') {
          try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
          window.scrollTo(0, 0);
          requestAnimationFrame(function () { window.scrollTo(0, 0); });
        }
      }
      // conta determinística: transparente enquanto a capa ainda está
      // sob a barra (topo) ou sob a faixa de baixo (dock). Sem depender
      // de interpretação de observador entre navegadores.
      var idaAntes = '';
      var medeVidro = function () {
        if (!valeAgora()) {
          raizHero.classList.remove('onmCapa', 'onmCapaTopo', 'onmCapaDock');
          return;
        }
        raizHero.classList.add('onmCapa');
        var r = medidor.getBoundingClientRect();
        raizHero.classList.toggle('onmCapaTopo', r.bottom > 72);
        // a folha encostou na marca do topo: ela sai, para não ficar por cima da folha
        var topoEl = document.querySelector('.top'), topoFim = topoEl ? topoEl.getBoundingClientRect().bottom : 72;
        raizHero.classList.toggle('onmCapaSob', r.bottom <= topoFim + 4 && r.bottom > 0);
        raizHero.classList.toggle('onmCapaDock', r.bottom > window.innerHeight - 76);
        // a folha cobriu a capa inteira: pode sumir com ela
        raizHero.classList.toggle('onmCapaFim', r.bottom <= 0);
        // progresso da saída da capa (0 = capa cheia, 1 = capa fora)
        var ida = 1 - (r.bottom / Math.max(1, window.innerHeight));
        // escrever no DOM todo quadro invalidava o estilo da capa inteira
        var val = Math.min(1, Math.max(0, ida)).toFixed(2);
        if (val !== idaAntes) { idaAntes = val; medidor.style.setProperty('--heroIda', val); }
      };
      medeVidro();
      // um quadro por rolagem, não um por evento
      var naFila = false;
      window.addEventListener('scroll', function () {
        if (naFila) return;
        naFila = true;
        requestAnimationFrame(function () { naFila = false; medeVidro(); });
      }, { passive: true });
      window.addEventListener('resize', medeVidro);
    }
  } catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }
})();

/* ══ Vida no scroll ═══════════════════════════════════════════════════
   O motor que dá movimento aos capítulos. Duas armas, ambas baratas:

   [data-surge]  o elemento surge quando entra na tela: o observador põe
                 a classe .vivo uma vez e o CSS faz a transição em
                 cascata. Zero trabalho por quadro.

   [data-viva]   o elemento flutua: desliza no eixo Y proporcional à
                 posição do seu centro em relação ao centro da janela.
                 O fator vem no atributo (negativo sobe, positivo desce).
                 [data-viva-extra] entra no fim do transform (a foto que
                 flutua dentro da moldura usa um scale ali, pra nunca
                 mostrar as bordas).

   Só transform e opacity: nada de layout, nada de pintura cara. Quem
   pede menos movimento (prefers-reduced-motion) não recebe nenhum, e
   o CSS garante que nada nasce escondido nesse caso nem sem JS. */
(function () {
  'use strict';
  try {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    // surgir: uma vez por elemento, e o observador se despede. A lista
    // de pendentes também é varrida no passo de rolagem: uma rolagem
    // muito rápida pode atravessar a seção entre dois quadros sem o
    // observador ver, e ninguém pode ficar escondido pra sempre.
    var pendS = [];
    var surgem = document.querySelectorAll('[data-surge]');
    if (surgem.length) {
      var ioS = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) {
          if (es[i].isIntersecting) acorda(es[i].target);
        }
      }, { threshold: 0.16 });
      for (var s = 0; s < surgem.length; s++) { pendS.push(surgem[s]); ioS.observe(surgem[s]); }
    }
    function acorda(el) {
      if (el.classList.contains('vivo')) return;
      el.classList.add('vivo');
      var i = pendS.indexOf(el);
      if (i > -1) pendS.splice(i, 1);
    }

    // flutuar: só os que estão perto da janela trabalham
    var alvos = [];
    var els = document.querySelectorAll('[data-viva]');
    for (var v = 0; v < els.length; v++) {
      var f = parseFloat(els[v].getAttribute('data-viva'));
      if (f) alvos.push({ el: els[v], f: f, extra: els[v].getAttribute('data-viva-extra') || '',
        min: parseInt(els[v].getAttribute('data-viva-min'), 10) || 0, perto: false });
    }
    if (!alvos.length && !pendS.length) return;

    var ioV = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        for (var a = 0; a < alvos.length; a++) {
          if (alvos[a].el === es[i].target) { alvos[a].perto = es[i].isIntersecting; break; }
        }
      }
      passo();
    }, { rootMargin: '25% 0px 25% 0px' });
    for (var o = 0; o < alvos.length; o++) ioV.observe(alvos[o].el);

    var pedindo = false;
    function passo() {
      pedindo = false;
      var vh = window.innerHeight;
      var meio = vh / 2;
      // acorda quem o observador não viu passar
      for (var pz = pendS.length - 1; pz >= 0; pz--) {
        if (pendS[pz].getBoundingClientRect().top < vh * 0.92) acorda(pendS[pz]);
      }
      for (var i = 0; i < alvos.length; i++) {
        var a = alvos[i];
        // todo alvo recebe a posição certa uma vez na carga: assim ele
        // já entra na tela deslocado, sem pulinho no primeiro quadro
        // abaixo da largura mínima o elemento volta ao lugar do CSS
        if (a.min && window.innerWidth < a.min) {
          if (a.el.style.transform) a.el.style.transform = '';
          a.iniciado = false;
          continue;
        }
        if (!a.perto && a.iniciado) continue;
        a.iniciado = true;
        var r = a.el.getBoundingClientRect();
        var desloca = ((r.top + r.height / 2) - meio) * a.f;
        a.el.style.transform = 'translate3d(0,' + desloca.toFixed(1) + 'px,0)' + (a.extra ? ' ' + a.extra : '');
      }
    }
    window.addEventListener('scroll', function () {
      if (!pedindo) { pedindo = true; requestAnimationFrame(passo); }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!pedindo) { pedindo = true; requestAnimationFrame(passo); }
    }, { passive: true });
    passo();
  } catch (e) { /* sem vida, mas com página */ }
})();

/* ── a gota que desce com a rolagem ──────────────────────────────────
   [data-queda]  a gota do capítulo de bordas. O CSS já a deixa visível
   no alto do espaço livre; aqui ela ganha um translate no eixo Y
   proporcional ao avanço da mídia pela janela, mais devagar que a
   rolagem, e pousa um pouco antes do final da foto: dali em diante
   viaja presa a ela. Voltar a rolagem desfaz o caminho.

   O motor é um laço de requestAnimationFrame ligado só enquanto o
   capítulo está perto da janela (IntersectionObserver): assim o
   movimento não depende do evento de scroll, que nem sempre chega
   quando a rolagem acontece dentro de outro contêiner (iOS, editor).
   O editor de temas re-renderiza a seção a cada mudança, então o mapa
   de alvos é refeito no shopify:section:load.

   A gota não olha o prefers-reduced-motion de propósito: a posição
   dela é função direta da rolagem da própria pessoa (parou de rolar,
   parou a gota), não uma animação autônoma, e no Windows basta
   desligar os efeitos de animação do sistema pra esse sinal ligar e
   congelar a cena pra todo mundo que testa assim. */
(function () {
  'use strict';
  try {
    var alvos = [];
    var rodando = false;

    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        for (var a = 0; a < alvos.length; a++) {
          if (alvos[a].mid === es[i].target) { alvos[a].perto = es[i].isIntersecting; break; }
        }
      }
      liga();
    }, { rootMargin: '20% 0px 20% 0px' }) : null;

    function pouso(a) {
      // a base da gota pousa na face da chapa: a fração vem do editor
      // (Pouso da gota, no data-queda), medida do topo da foto. O
      // caminho parte do topo da mídia, o espaço livre acima da chapa.
      var r = a.fig.getBoundingClientRect();
      var mr = a.mid.getBoundingClientRect();
      var h = a.el.offsetHeight;
      if (!r.height || !h) return null;
      var fim = (r.top - mr.top) + r.height * a.frac - h;
      return { fim: fim < 0 ? 0 : fim, mr: mr, r: r };
    }

    function roda() {
      var algum = false;
      var vh = window.innerHeight;
      for (var i = 0; i < alvos.length; i++) {
        var a = alvos[i];
        if (!a.perto) continue;
        var g = pouso(a);
        if (!g) continue;
        algum = true;
        // o avanço: 0 quando a mídia entra por baixo, 1 quando o final
        // da foto chega perto do meio da janela (posição de leitura)
        var p = (vh - g.mr.top) / (vh * 0.45 + g.mr.height);
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        // suaviza: em vez de saltar pro alvo (a roda do mouse rola em
        // degraus), a gota se aproxima dele um tanto por quadro
        var alvo = p * g.fim;
        if (a.pos == null) a.pos = alvo;
        a.pos += (alvo - a.pos) * 0.14;
        if (Math.abs(alvo - a.pos) < 0.15) a.pos = alvo;
        a.el.style.transform = 'translate3d(-50%,' + a.pos.toFixed(1) + 'px,0)';
      }
      if (algum) { requestAnimationFrame(roda); } else { rodando = false; }
    }

    function liga() {
      if (!rodando) { rodando = true; requestAnimationFrame(roda); }
    }

    function montar() {
      if (io) { for (var i = 0; i < alvos.length; i++) { io.unobserve(alvos[i].mid); } }
      alvos = [];
      var els = document.querySelectorAll('[data-queda]');
      for (var j = 0; j < els.length; j++) {
        var mid = els[j].parentElement;
        var fig = mid ? mid.querySelector('.cap__f') : null;
        var frac = parseFloat(els[j].getAttribute('data-queda'));
        if (!(frac > 0)) frac = 52;
        if (fig) alvos.push({ el: els[j], mid: mid, fig: fig, frac: frac / 100, pos: null, perto: !io });
      }
      if (io) { for (var k = 0; k < alvos.length; k++) { io.observe(alvos[k].mid); } }
      liga();
    }

    window.addEventListener('resize', liga, { passive: true });
    window.addEventListener('load', liga, { passive: true });
    document.addEventListener('shopify:section:load', montar);
    montar();
  } catch (e) { /* a página segue seca */ }
})();

/* ── conversas no WhatsApp ───────────────────────────────────────────
   [data-zap]  qualquer link que leva pra conversa. O clique vira um
   evento no dataLayer (GTM) e no gtag, quando existirem, com a origem
   (pdp, duvidas, rodape, contato) e o produto da página. Sem nenhum
   dos dois instalados, o clique segue normal e nada acontece. */
(function () {
  'use strict';
  try {
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('[data-zap]') : null;
      if (!a) return;
      var dados = {
        event: 'contato_whatsapp',
        zap_origem: a.getAttribute('data-zap') || 'site',
        zap_pagina: location.pathname
      };
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(dados);
      if (typeof window.gtag === 'function') {
        gtag('event', 'contato_whatsapp', {
          origem: dados.zap_origem,
          pagina: dados.zap_pagina
        });
      }
      if (typeof window.fbq === 'function') fbq('trackCustom', 'ContatoWhatsApp', dados);
    }, { passive: true });
  } catch (e) { /* o link continua funcionando */ }
})();

/* ══ Reta final da campanha ═══════════════════════════════════════
   A frase já vem pronta do servidor (snippets/onm-final.liquid), então
   quem chega sem JS lê a mesma coisa. Aqui só o minuto vira, e a linha
   sai do ar sozinha quando o prazo passa, em vez de mostrar tempo
   negativo. De propósito não conta segundo: número correndo é o visual
   que a marca não quer, e ninguém decide um móvel em quarenta segundos.
   A varredura é refeita a cada volta, para pegar o que a gaveta da
   caixa e o "ver mais" da coleção desenham depois do carregamento.
   ═══════════════════════════════════════════════════════════════ */
try {
(function () {
  'use strict';

  function conta(seg, curta) {
    var d = Math.floor(seg / 86400);
    var h = Math.floor((seg % 86400) / 3600);
    var m = Math.floor((seg % 3600) / 60);
    var t;
    if (d > 0) t = (d === 1 ? '1 dia e ' : d + ' dias e ') + h + 'h';
    else if (h > 0) t = h + 'h' + (m > 0 ? (m < 10 ? '0' : '') + m : '');
    else if (m > 0) t = m + ' min';
    else t = 'menos de 1 min';
    return curta ? t : 'acaba em ' + t;
  }

  function rotulo(seg) {
    var dcal = Math.floor((seg + 86399) / 86400);
    if (dcal >= 2) return 'Últimos ' + dcal + ' dias';
    if (seg > 10800) return 'Último dia';
    return 'Últimas horas';
  }

  var relogio = null;

  function passo() {
    var els = document.querySelectorAll('[data-final]');
    if (!els.length) return;
    var agora = Math.floor(Date.now() / 1000);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var fim = parseInt(el.getAttribute('data-fim'), 10);
      if (!fim) continue;
      var seg = fim - agora;
      if (seg <= 0) { if (el.parentNode) el.parentNode.removeChild(el); continue; }
      var c = el.hasAttribute('data-final-conta') ? el : el.querySelector('[data-final-conta]');
      if (c) c.textContent = conta(seg, el.getAttribute('data-final-modo') === 'curta');
      var r = el.hasAttribute('data-final-rot') ? el : el.querySelector('[data-final-rot]');
      if (r) r.textContent = rotulo(seg);
    }
  }

  passo();
  relogio = setInterval(passo, 30000);
  document.addEventListener('onm:cards', passo);
  document.addEventListener('onm:abriu', passo);
  document.addEventListener('shopify:section:load', passo);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) passo(); });
})();
} catch (e) { if (window.console && console.warn) console.warn('ON: um bloco do tema falhou e o resto seguiu.', e); }
